<template>
  <div class="topP">
    <div class="left_logo">
      JM内务管理
    </div>
    <div class="topNav_right">
      <span style="line-height: 60px;">
        <span class="nav-menu-inner">
          <span class="nav-name">欢迎您，{{realname}}</span>
        </span>
      </span>
      <a class="nav-menu" @click="password=true">
        <span class="nav-menu-inner">
          <Icon type="ios-locked"></Icon>
          <span class="nav-name">修改密码</span>
        </span>
      </a>
      <a class="nav-menu" @click="logout">
        <span class="nav-menu-inner">
          <Icon type="log-out"></Icon>
          <span class="nav-name">安全退出</span>
        </span>
      </a>

    </div>
    <Modal v-model="password" class-name="psw" width="520">
      <p slot="header" style="color:#fff;text-align:center">
        <Icon type="information-circled"></Icon>
        <span> 修改密码</span>
      </p>
      <div style="text-align:center">
        <Form  ref="formInline" :model="formInline" inline :label-width="100">
          <div>
            <Form-item label="原密码：">
              <Input v-model="old_psw" type="password"  placeholder="请输入"></Input>
            </Form-item>
          </div>
          <div>
            <Form-item label="新密码：">
              <Input v-model="new_psw" type="password"  placeholder="请输入"></Input>
            </Form-item>
          </div>
        </Form>

      </div>
      <div slot="footer">
        <Button  style="background-color: #00c0ff;color: #fff" @click="edit_psw">修改</Button>
        <Button  @click="password=false">取消</Button>
      </div>
    </Modal>

  </div>
</template>

<script>
import "assets/../global/setting";
export default {
  data() {
    return {
      headers: { token: "swgykj9527" },
      action: parameters.domain + "/sys/bookmealsetting/uploadbg",
      imgSrc: "",
      realname: "",
      username: "",
      _id:"",
        password:false,
        old_psw:"",
        new_psw:"",
        formInline:{},
    }
  },
  components: {

  },
  methods: {
      edit_psw:function(){
      var that = this;
      let params = {};
      params.url = "/sys/userinfo/changepsw";
          params.token = window.localStorage.getItem("token");
          params.data = {};
          if(this.old_psw!=''){
              params.data.oldpsw=this.old_psw
          }else{
              this.$Notice.warning({
                  title: '请输入原密码'
              });
              return;
          }
          if(this.new_psw!=''){
              params.data.newpsw=this.new_psw
          }else{
              this.$Notice.warning({
                  title: '请输入新密码'
              });
              return;
          }
          params.data._id=this._id;
          params.data.username=this.username;
          console.log(params.data);
          params.success = function (res) {
              that.$Notice.success({
                  title: '修改成功'
              });
              that.password=false;
          };
          params.error=function(res){
              that.$Notice.error({
                  title: res.message,
              });
          }
          this.ajaxPost(params);
    },
    logout:function () {
        this.removeKey('token');
        this.removeKey('realname');
        this.removeKey('username');
        this.$router.push('/login');
        return;
    }
  },
  mounted(){
//    this.showPicture();
      this.realname = this.getKey('realname');
      this.username = window.localStorage.getItem('userName');
      this._id = window.localStorage.getItem('_id');
  }
}
</script>

<style lang="scss">
    .topP{
      background: url("../assets/topNav/top.png");
      height: 61px;
      position: relative;
      width: 100%;
        .left_logo{
          font-size: 20px;
          color: #fff;
          font-weight: bold;
          padding-left: 90px;
          line-height: 61px;
          display: inline-block;
        }
        .topNav_right{
          position: relative;
          float: right;
          height: 100%;
          width: 50%;
          font-size: 18px;
          text-align: right;
          color: white;
    .nav-menu {
      color: #fff;
      display: inline-flex;
      align-items: center;
      height: 60px;
      text-align: center;
      vertical-align: top;
      padding: 0 0.5%;
      position: relative;
    .nav-menu-inner{
      display: inline-block;
      position: relative;
    }
    .title-icon {
      height: 40px;
      width: 40px;
      position: absolute;
      right: 0px;
      top: 0px;
      font-size: 20px;
      cursor: pointer;
    }
    .title-icon:hover {
      background: rgba(255,255,255,0.3);
    }
    }
    .nav-menu:hover {
      /*color:#ff6600;*/
      color:#fff76c;
      background: rgba(255,255,255,0.4);
    .nav_choose{
      color: #fff76c;
    }
    }
    .nav_choose{
      color:#fff ;
      font-size: 1.9rem;
    }
    .cur{
      color: #fff76c;
    .nav_choose{
      color: #fff76c;
    }
    }

    .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active:not(.ivu-menu-submenu){
      background-color: #fff;
      color: black;
    }

    }
        }
    .psw{
    .ivu-modal-header{
      background-color: #00c0ff;
    }
    .ivu-modal-close .ivu-icon-ios-close-empty{
      color: #fff;
    }
    }

</style>




// WEBPACK FOOTER //
// src/components/top.vue